export default __webpack_public_path__ + "static/media/er.205b5980.svg";